import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AcompanhamentoDocumentoDepr, estadosAcompanhamentoDocumentoDepr, periodosAcompanhamentoDocumentoDepr, tiposAcompanhamentoDocumentoDepr } from 'src/app/model/acompanhamento-documento-depr.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AcompanhamentoDeprService } from '../acompanhamento-depr.service';
import { DatePipe } from '@angular/common';
import {MensagemService} from '../../../mensagem.service';

@Component({
  selector: 'app-acompanhamento-depr-pesquisa',
  templateUrl: './acompanhamento-depr-pesquisa.component.html',
  styleUrls: ['./acompanhamento-depr-pesquisa.component.scss'],
  standalone: false,
})
export class AcompanhamentoDeprPesquisaComponent implements OnInit {

  private atributosPaginacaoComponenteListagem: EntityPagedResult<AcompanhamentoDocumentoDepr>;
  private opcoesPaginacao: number[];
  public pesquisaForm: UntypedFormGroup;
  public podeEnviar: boolean = false;
  public ehAgenteFinanceiro: boolean = false;
  public agentesFinanceiros: AgenteFinanceiro[];
  public cnpjUsuario: string;
  public valoresPesquisaForm: any;
  public pesquisado: boolean = false;

  public valoresStatus = estadosAcompanhamentoDocumentoDepr;
  public tiposDosumento = tiposAcompanhamentoDocumentoDepr;
  public periodos = periodosAcompanhamentoDocumentoDepr;
  public competencias: number[];

  public acompanhamentos: AcompanhamentoDocumentoDepr[];

  constructor(private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private bnUsuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private acompanhamentoDeprService: AcompanhamentoDeprService,
    private datePipe: DatePipe,
    private mensagemService: MensagemService,) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.pesquisaForm = this.formBuilder.group({
      dataAbertura: null,
      dataFechamento: null,
      tipoJanela: null,
      modalidadeGarantia: null,
    });

    this.opcoesPaginacao = [10, 15, 20];

    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  ngOnInit(): void {
    this.pesquisaForm = this.createReactiveForm();

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEnviar = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];

      this.bnUsuarioService.usuario$.subscribe(usuario => {
        this.cnpjUsuario = usuario.cnpj;
        this.construirFormulario();
      });
    });

    this.carregarListaAnos();
  }

  private validarCnpjUsuarioLogado() {
    if (this.cnpjUsuario == null) {
      return null;
    }

    return this.agentesFinanceiros.filter(a => a.cnpj === this.cnpjUsuario)[0]?.cnpj || null;
  }

  createReactiveForm(): UntypedFormGroup {

    const form = this.formBuilder.group({
      cnpjAgenteFinanceiro: null,
      statusArquivo: null,
      tipoDocumento: null,
      dataEnvioInicial:null,
      dataEnvioFinal: null,
      competencia: null,
      periodo: null,
      identificadorArquivo: [null, Validators.pattern(/^\d{1,6}-\d{4}$/) ]
    });

    return form;
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaAcompanhamentoOperacaoForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : null;

    if (this.valoresPesquisaForm) {
      this.pesquisaForm.patchValue({
        cnpjAgenteFinanceiro: this.validarCnpjUsuarioLogado(),
        statusArquivo: this.valoresPesquisaForm.statusProtocolo ? this.valoresPesquisaForm.statusArquivo : null,
        tipoDocumento: this.valoresPesquisaForm.idAcompanhamento ? this.valoresPesquisaForm.tipoDocumento : null,
        dataEnvioInicial: this.valoresPesquisaForm.dataEnvioInicial ? this.valoresPesquisaForm.dataEnvioInicial : null,
        dataEnvioFinal: this.valoresPesquisaForm.dataEnvioFinal ? this.valoresPesquisaForm.dataEnvioFinal : null,
        competencia: this.valoresPesquisaForm.competencia ? this.valoresPesquisaForm.competencia : null,
        periodo: this.valoresPesquisaForm.periodo ? this.valoresPesquisaForm.periodo : null,
        identificadorArquivo: this.valoresPesquisaForm.identificadorArquivo ? this.valoresPesquisaForm.identificadorArquivo : null,
      });

    }
    if (this.cnpjUsuario != null) {
      this.pesquisaForm.patchValue({ cnpjAgenteFinanceiro: this.cnpjUsuario });
      this.pesquisaForm.controls.cnpjAgenteFinanceiro.disable();
    }
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.valoresPesquisaForm = novosValores;
      this.pesquisado = false;
      sessionStorage.setItem('valoresPesquisaAcompanhamentoOperacaoForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  private carregarListaAnos() {
    const anoInicial = 2022;
    const anoAtual = new Date().getFullYear();

    this.competencias = Array.from(
      { length: anoAtual - anoInicial + 1 },
      (_, i) => anoInicial + i
    );
  }

  getParams() {
    const form = this.pesquisaForm.getRawValue();
    let params: any = {};

    if (form.cnpjAgenteFinanceiro) {
      params.cnpjAgenteFinanceiro = form.cnpjAgenteFinanceiro;
    }
    if (form.dataEnvioInicial) {
      params.dataEnvioInicial = this.datePipe.transform(form.dataEnvioInicial,'yyyyMMdd');
    }
    if (form.dataEnvioFinal) {
      console.log(form.dataEnvioFinal);
      params.dataEnvioFinal = this.datePipe.transform(form.dataEnvioFinal, 'yyyyMMdd');
    }
    if (form.statusArquivo) {
      params.statusArquivo = form.statusArquivo;
    }
    if (form.tipoDocumento) {
      params.tipoDocumento = form.tipoDocumento;
    }
    if (form.competencia) {
      params.competencia = form.competencia;
    }
    if (form.periodo) {
      params.periodo = form.periodo;
    }
    if (form.identificadorArquivo) {
      let identificador = form.identificadorArquivo.toString().trim();
      let partes = [];
      partes = identificador.split('-');
      params.identificadorArquivo = parseInt(partes[0]);
      params.anoArquivo = partes[1];

    }
    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    return params;
  }

  buscar() {
    if(this.pesquisaForm.valid) {
      if (!this.pesquisado) {
        this.atributosPaginacaoComponenteListagem.page = 1;
      }
      this.acompanhamentoDeprService.getAcompanhamentos(this.getParams()).subscribe(resp => {
        this.acompanhamentos = resp.resultados;
        this.atributosPaginacaoComponenteListagem.count = resp ? resp.totalRegistrosSemPaginacao : 0;
        this.pesquisado = true;
      });
    }
  }

  limpar() {
    this.pesquisado = false;
    this.pesquisaForm.reset();
    this.pesquisaForm.patchValue({ cnpjAgenteFinanceiro: this.validarCnpjUsuarioLogado() });
    if (this.cnpjUsuario != null) {
      this.pesquisaForm.controls.cnpjAgenteFinanceiro.disable();
    }
  }

  podeEscolherAgente() {
    return this.cnpjUsuario == null;
  }

  mudancaPagina(novaPagina: EntityPagedResult<AcompanhamentoDocumentoDepr>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar();
  }

}
